import React from 'react';
import {NavLink} from 'react-router-dom';

export const Nav = ({currentUser, clientData}) => {

  const navigateHome = () => window.location = "/";

  const handleLogout = () => {
    fetch('/apilogout', { method: 'POST', credentials: 'include' }).then(() => {
      window.location = "/login";
    });
  };

 return (
            <div className="navWrapper">
              <NavLink  to="/"><img onClick={navigateHome} className="fusaLogo" src="https://res.cloudinary.com/dof3z7iuh/image/upload/v1770844655/Guard_Services___NEW_Logo_RGB-02_1_jmqeji.png"></img></NavLink>
              <ul className="navigation">
              <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/clientRequests"><li className="navItem">Guard Requests</li></NavLink>
              <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/shifts"><li className="navItem">Shifts</li></NavLink>
              {/* <NavLink to="/createTicket"><li className="navItem">Create Service Request</li></NavLink> */}
              <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/invoices"><li className="navItem">Invoices</li></NavLink>
              {/* <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/issues"><li className="navItem">Issues</li></NavLink> */}
              {currentUser && currentUser.role === 'admin' && (
                <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/admin/users"><li className="navItem">Admin</li></NavLink>
              )}
              <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/profile"><li className="navItem">Profile</li></NavLink>
              {/* <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/locations"><li className="navItem">Locations</li></NavLink> */}
              <a onClick={handleLogout} style={{cursor: 'pointer'}}><li className="navItem">Logout</li></a>
              </ul>
              <div style={{width: '220px', textAlign: 'right'}}>
                {clientData && clientData.logoUrl && <img style={{maxHeight: '50px', marginRight: '20px'}} src={clientData.logoUrl}></img>}
              </div>
            </div>
 )
}
